module.exports = __webpack_public_path__ + "img/DSC_4442.9c7d099b.jpg";